import { useMutation } from 'react-query';
import { UserPayload, timefitBackend } from '../../../Shared/Services/TimefitBackend';

export function useAdminCreateUser() {
  const mutation = async (payload: UserPayload) => {
    const currentUser = await timefitBackend.getCurrentAuthUser();
    const userCredential = await timefitBackend.createUserAuth(payload.email, payload.password);
    await timefitBackend.setCurrentAuthUser(currentUser!);
    await timefitBackend.createUserData(payload, userCredential);
  };

  return useMutation(mutation);
}
